import { FC } from 'react';
import { Typography } from '@fuxi/eevee-ui';
import { TextProps } from 'antd/es/typography/Text';

type AmountTextProps = TextProps;

export const AmountText: FC<AmountTextProps> = props => {
  return <Typography.Text style={{ color: 'var(--color-warning)', fontFamily: 'D-DIN-PRO' }} {...props} />;
};
